import React, { ChangeEvent } from "react";
import { ErrorMessage, Input as BronsonInput } from "@vwfs-bronson/bronson-react";
import { GenericFieldHTMLAttributes, useField } from "formik";
import { Label } from "./Label";
import { FormField } from "@common/types";

interface Props {
  type?: string;
  formField: FormField;
  label?: string;
  infoIconText?: React.ReactNode;
  addonText?: React.ReactNode;
  reversed?: boolean;
  readOnly?: boolean;
  adjustValueOnBlur?: (value: string) => string;
  maxLength?: string;
  placeholder?: string;
  onBlur?: (event: ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: any;
  required?: boolean;
}

export const Input: React.FC<Props & Omit<GenericFieldHTMLAttributes, "name">> = ({ formField, label, infoIconText, readOnly, adjustValueOnBlur, required = false, ...props }) => {
  const { fieldName } = formField;
  const [fieldProps, { touched, error }, { setValue, setTouched }] = useField<string>(fieldName);

  const errorMessage = touched && error ? <ErrorMessage id={fieldName}>{error}</ErrorMessage> : null;

  const onBlur = adjustValueOnBlur
    ? (event: ChangeEvent<HTMLInputElement>) => {
      setValue(adjustValueOnBlur(event.target.value), true);
      setTouched(true);
      if (props?.onBlur) {
        props.onBlur(event);
      }
    }
    : (event: ChangeEvent<HTMLInputElement>) => {
      fieldProps.onBlur(event);
      if (props?.onBlur) {
        props.onBlur(event);
      }
    };
  return (
    <>
      {label && <Label htmlFor={fieldName} text={label} infoIconText={infoIconText} />}
      <BronsonInput {...(fieldProps as any)} {...props} id={fieldName} error={!!errorMessage} readOnly={readOnly} onBlur={onBlur} aria-describedby={`error-${fieldName}`} required={required} />
      {errorMessage}
    </>
  );
};
